import {RouterModule} from '@angular/router';
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

// Bootstrap Modules
import {NgbDropdownModule} from '@ng-bootstrap/ng-bootstrap';

import {NgbdModalConfirm} from './modals/modal.confirm/modal.confirm';

// Pipes
import {RecortarPipe} from './pipes/recortar';
import {MarcoPagesComponent} from './components/marco-pages/marco-pages.component';
import {ButtonSectionComponent} from './components/button-section/button-section.component';
import {PrimeNgModule} from '@modules/prime-ng/prime-ng.module';
import {tipoUserPipe} from './pipes/tipoUser.pipe';
import {BarComponent} from './components/bar/bar.component';
import { tipoInputPipe } from './pipes/tipoInput.pipe';
import { FormularioDinamicoComponent } from './components/formulario-dinamico/formulario-dinamico.component';
import { UtilsModule } from '@modules/utils/utils.module';
import { UsuarioNullPipe } from './pipes/usuario-null.pipe';
import { estadoDenunciaPipe } from './pipes/estadoDenuncia.pipe';
import { ObligatoriedadPipe } from './pipes/obligatoriedad.pipe';
import { objetoCustomPipe } from './pipes/objetoCustom.pipe';

@NgModule({
  declarations: [
    NgbdModalConfirm,
    RecortarPipe,
    MarcoPagesComponent,
    ButtonSectionComponent,
    tipoUserPipe,
    BarComponent,
    tipoInputPipe,
    FormularioDinamicoComponent,
    UsuarioNullPipe
    ,estadoDenunciaPipe,
    ObligatoriedadPipe,
    objetoCustomPipe
  ],
  imports: [CommonModule, RouterModule, NgbDropdownModule, PrimeNgModule],
  exports: [
    NgbdModalConfirm,
    NgbDropdownModule,
    RecortarPipe,
    ButtonSectionComponent,
    FormularioDinamicoComponent,
    tipoUserPipe,
    BarComponent,
    UtilsModule,
    tipoInputPipe,
    UsuarioNullPipe,
    estadoDenunciaPipe,
    ObligatoriedadPipe,objetoCustomPipe
  ],
})
export class SharedModule {}
